import { css, jsx } from '@emotion/core';

import { bp, colors, form as formStyle, space } from '@/styles';

const style = {
  filters: css`
    padding: 4px 18px 4px;
    margin-bottom: 24px;
    margin-left: -16px;
    margin-right: -16px;
    background: #fff;
    box-shadow: 0 6px 12px 0 rgba(35, 32, 32, 0.1);
    border-radius: 0px;
    @media ${bp.md} {
      border-radius: 4px;
    }
    @media ${bp.md} {
      padding: 8px 32px 4px;
      border-radius: 4px;
      margin-left: initial;
      margin-right: initial;
    }
    @media print {
      display: none;
    }
    .ant-collapse {
      &-header {
        padding: 20px 0 !important;
      }
      &-content-box {
        padding: 0;
        .ant-collapse-content-box {
          padding: 0 0 20px !important;
        }
      }
      &-arrow {
        right: 0 !important;
        left: auto !important;
      }
    }
    & > div:first-of-type {
      margin-bottom: 20px;
      & > div {
        border-bottom: none !important;
        & > div:first-of-type {
          border-bottom: 1px solid ${colors.accentGrayLight};
          margin-bottom: 0px;
        }
      }
    }
  `,
  filterSearch: css`
    display: flex;
    border-bottom: 1px solid ${colors.accentGrayLight};
    padding-bottom: 20px;
  `,
  filterTag: css`
    height: 30px;
    min-width: 83px;
    border-radius: 2px;
    border: 1px solid ${colors.accentGrayLight};
    background-color: #fff;
    font-size: 1.2rem;
    display: inline-flex;
    align-items: center;
    font-weight: 900;
    .anticon-close {
      color: ${colors.secondaryGray};
      font-size: 1.4rem;
      margin-left: auto;
      margin-right: 4px;
      transform: translateX(4px);
    }
  `,
  filterTags: css`
    visibility: visible;
    opacity: 1;
    transition: all 0.3s $ease-in-out;
    margin-bottom: 12px;
  `,
};

export default style;
